module.exports = __webpack_public_path__ + "static/media/tech2.feab711b.jpeg";